import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { MouseEvent } from "react";
import { useTheme } from "@mui/material";
import { WeekDays } from "../../OpeningTimes/WeekDays";
import { RoundedToggleButton } from "../../OpeningTimes/RoundedToggleButton";

interface WeekDaysToggleButtonGroupProps {
  selection: Array<WeekDays>;
  onChange: (event: MouseEvent<HTMLElement>, newSelection: Array<WeekDays>) => void;
}

export default function WeekDaysToggleButtonGroup({
  selection,
  ...props
}: WeekDaysToggleButtonGroupProps) {
  const theme = useTheme();
  return (
    <ToggleButtonGroup key="SupplierWeekDays" value={selection} {...props} size="small">
      <RoundedToggleButton theme={theme} value={WeekDays.Monday}>
        {WeekDays.Monday}
      </RoundedToggleButton>
      <RoundedToggleButton theme={theme} value={WeekDays.Tuesday}>
        {WeekDays.Tuesday}
      </RoundedToggleButton>
      <RoundedToggleButton theme={theme} value={WeekDays.Wednesday}>
        {WeekDays.Wednesday}
      </RoundedToggleButton>
      <RoundedToggleButton theme={theme} value={WeekDays.Thursday}>
        {WeekDays.Thursday}
      </RoundedToggleButton>
      <RoundedToggleButton theme={theme} value={WeekDays.Friday}>
        {WeekDays.Friday}
      </RoundedToggleButton>
      <RoundedToggleButton theme={theme} value={WeekDays.Saturday}>
        {WeekDays.Saturday}
      </RoundedToggleButton>
      <RoundedToggleButton theme={theme} value={WeekDays.Sunday}>
        {WeekDays.Sunday}
      </RoundedToggleButton>
    </ToggleButtonGroup>
  );
}
